import { render } from "./DicoFrame.vue?vue&type=template&id=7052c563&scoped=true"
import script from "./DicoFrame.vue?vue&type=script&lang=js"
export * from "./DicoFrame.vue?vue&type=script&lang=js"

import "./DicoFrame.vue?vue&type=style&index=0&id=7052c563&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7052c563"]])

export default __exports__